import React from 'react';
import classnames from 'classnames';

import Tabs from 'dpl/common/design_system/Tabs';

import useBreederProfileTabs from '../../hooks/useBreederProfileTabs';
import useBreederProfileMobileLayout from '../../hooks/useBreederProfileMobileLayout';

export default function BreederProfileTabs() {
  const { isNewMobileLayout } = useBreederProfileMobileLayout();
  const { activeTabIndex, tabNames, onTabClick } = useBreederProfileTabs();

  return (
    <div
      className={classnames('BreederProfileTabs container-xxl mb6 mb12-md', {
        'bg-sand sticky top-0 z-999': isNewMobileLayout
      })}
    >
      <Tabs
        activeTabIndex={activeTabIndex}
        tabItems={tabNames}
        onTabClick={onTabClick}
        classes={{
          list: 'gap-24 md:gap-32',
          tab: 'font-16 md:font-18 fw-medium pv4',
          activeTab: 'black',
          inactiveTab: 'tertiary',
          glider: 'bb b--black'
        }}
      />
      <span
        className="db bb b--default"
        // Make active tab's 1px bottom border overlap this divider line
        style={{ marginTop: -1 }}
      />
    </div>
  );
}
